/*
 *   File : update-password.js
 *   Author URI : https://evoqins.com
 *   Description : UI element which asks for updating password.
 *   Integrations : null
 *   Version : v1.1
 */
/* import packages */
import { Fragment, useEffect, useState } from "react";

/* import components */
import { GradientButton, SecondaryButton } from "../Cta";
import { Icon } from "../Icon";
import { CustomTextInput } from "../FormElements";

/* import styles */
import style from "../../Styles/Components/delete.module.scss";

/* import helper */
import { closeModal } from "../../Helper/helper-function";
import APIService from "../../Services/api-service";
import { toast } from "react-toastify";


const UpdatePassword = (props) => {
    const [oldPassword, setOldPassword] = useState("");
    const [oldPasswordError, setOldPasswordError] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordError, setNewPasswordError] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [validationErrors, setValidationErrors] = useState([]);
    const [reset, setReset] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        var my_modal = document.getElementById("update-password");
        my_modal.addEventListener("hidden.bs.modal", () => {
            setNewPassword('');
            setReset(false);
            setConfirmPassword('');
            setOldPassword('');
            setValidationErrors([]);
            props.closeModal();
        });
        //eslint-disable-next-line
    }, [props.close]);



    function _handleOldPassword(value, field) {
        setOldPasswordError("");
        setOldPassword(value);
    }

    function _handleNewPassword(value, field) {
        setNewPasswordError('');
        setNewPassword(value);
    }

    function _handleConfirmPassword(value, field) {
        setConfirmPasswordError('');
        setConfirmPassword(value);
    }

    // validation for fields
    function _validateForm() {
        let valid = true;
        // const password_validator = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/; //password validator regex       


        if (oldPassword === '') {
            valid = false;
            setOldPasswordError("Old password required");
        }

        if (newPassword === '') {
            valid = false;
            setNewPasswordError("New password required");
        }

        if (confirmPassword === '') {
            valid = false;
            setConfirmPasswordError('Confirm password required');
        }


        if (newPassword !== confirmPassword) {
            valid = false;
            setConfirmPasswordError('New & Confirm passwords must match');
        }

        if (valid === true) {
            _resetPassword();
        }
    }



    // API - reset password
    const _resetPassword = () => {
        setLoader(true);
        const url = "auth/change-password";

        const data = {
            "current_password": oldPassword,
            "new_password": newPassword
        }

        APIService(true, url, data).then((response) => {
            if (response.status_code === 200) {
                setNewPassword('');
                setConfirmPassword('');
                setReset(true);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error"
                });
            }
            setLoader(false);
        });
    }

    return (
        <div className={`modal fade ${style.e_approve_kyc}`}
            id="update-password"
            tabIndex="-1"
            aria-labelledby="update-password"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content bg-white  padding-32px-all ${style.e_content} `}>
                    {
                        !reset ?
                            <Fragment>
                                <div className="col-12 d-flex justify-content-between">
                                    <h3 className="color-black e-poppins-semi-bold e-font-18">
                                        Set password
                                    </h3>
                                    <Icon icon="close"
                                        size={24}
                                        className="cursor-pointer ms-auto e-modal-close-btn"
                                        data-bs-dismiss="modal" />
                                </div>
                                <div className="col-md-7  padding-28px-top position-relative">
                                    <CustomTextInput label="Old password"
                                        value={oldPassword}
                                        type={showOldPassword ? "text" : "password"}
                                        postfix="*"
                                        className="mb-3 pa"
                                        error={oldPasswordError}
                                        onEnter={_validateForm}
                                        password_icon={true}
                                        showPassword={() => {
                                            setShowOldPassword(!showOldPassword)
                                        }}
                                        valueChange={(value) => _handleOldPassword(value, 'oldPassword')} />
                                </div>
                                <div className="col-md-7  padding-20px-top position-relative">
                                    <CustomTextInput label="New password"
                                        value={newPassword}
                                        type={showNewPassword ? "text" : "password"}
                                        postfix="*"
                                        className="mb-3 pa"
                                        error={newPasswordError}
                                        onEnter={_validateForm}
                                        password_icon={true}
                                        showPassword={() => {
                                            setShowNewPassword(!showNewPassword)
                                        }}
                                        valueChange={(value) => _handleNewPassword(value, 'newPassword')} />
                                </div>
                                <div className="col-md-7  padding-20px-top position-relative">
                                    <CustomTextInput label="Confirm new password"
                                        value={confirmPassword}
                                        type={showConfirmPassword ? "text" : "password"}
                                        postfix="*"
                                        className="mb-3"
                                        error={confirmPasswordError}
                                        onEnter={_validateForm}
                                        password_icon={true}
                                        showPassword={() => {
                                            setShowConfirmPassword(!showConfirmPassword)
                                        }}
                                        valueChange={(value) => _handleConfirmPassword(value, 'confirmPassword')} />
                                </div>
                                <div className="col-md-7">
                                    <SecondaryButton label="Cancel" className="me-3"
                                        cancel="modal" />
                                    <GradientButton label="Update password"
                                        loading={loader}
                                        className="px-3 padding-12px-tb e-font-16 mt-4"
                                        onPress={_validateForm} />
                                </div>

                            </Fragment>
                            :
                            <Fragment>

                                <div className="col-12 d-flex justify-content-between">

                                    <Icon icon="close"
                                        size={24}
                                        className="cursor-pointer ms-auto e-modal-close-btn"
                                        data-bs-dismiss="modal" />
                                </div>
                                <img draggable={false} src={require("../../Assets/Images/Modal/kyc-success.png")}
                                    alt="Kyc success"
                                    width={72}
                                    height={72}
                                    className="mx-auto"
                                />


                                <h6 className="color-eerie-black e-poppins-medium e-font-18 mt-3 mb-0 text-center">
                                    Password reset!
                                </h6>
                                <p className="color-outer-space e-poppins-regular e-font-14 mt-2 mb-0 px-5 text-center letter-spacing-point28">
                                    your password has been successfully reset, click below to continue your access.
                                </p>
                                <div className="d-flex  justify-content-center margin-32px-top margin-32px-bottom w-100">

                                    <GradientButton label="Back"
                                        className="padding-12px-tb e-font-16 "
                                        cancel="modal"
                                    />
                                </div>

                            </Fragment>
                    }
                </div>
            </div>
        </div>
    )
}


UpdatePassword.defaultProps = {
    closeModal: () => { }
}

export default UpdatePassword
